import type { BenefitItem } from '../countryContent'
import BenefitCardLeft from './BenefitCardLeft'
import BenefitCardRight from './BenefitCardRight'

interface BenefitCardProps {
  benefit: BenefitItem
  imagePosition: 'left' | 'right'
}

const BenefitCard = ({ benefit, imagePosition }: BenefitCardProps) => {
  if (imagePosition === 'left') {
    return <BenefitCardLeft benefit={benefit} />
  }

  return <BenefitCardRight benefit={benefit} />
}

export default BenefitCard
